// pi = 3.14159265359;   // Just pi [1].
// Z_0 = 120*pi;         // Impedance of vacum [Ohm].
// c_0 = 3E8;            // Speed of light in vacum [m/s].

// --------------------------------------------------------------------------

export function log10(x) {
   var y;
   y = Math.log(x)/Math.log(10);   // log_a(x) = log_b(x) / log_b(a)
   return(y);
}

export function exp10(x) {
   var y;
   y = Math.exp(x*Math.log(10));   // a^x = b^(x * log_b(a))
   return(y);
}

// --------------------------------------------------------------------------

export function cmd_convert_dBW2dBmW(my_form) {
   var dBW, dBm, W;
   dBW = parseFloat(my_form.power_dBW.value);
   if (isNaN(dBW)) {
      my_form.power_dBW.value = "";
      window.alert("Enter the power in dBW.");
      return(0);
      }
   W = exp10(dBW/10);
   dBm = dBW+30;
   my_form.power_dBW.value = dBW;
   my_form.power_dBm.value = dBm;
   my_form.power_W.value = W;
   return(1);
}

export function cmd_convert_dBm2dBWW(my_form) {
   var dBW, dBm, W;
   dBm = parseFloat(my_form.power_dBm.value);
   if (isNaN(dBm)) {
      my_form.power_dBm.value = "";
      window.alert("Enter the power in dBm.");
      return(0);
      }
   dBW = dBm-30;
   W = exp10(dBW/10);
   my_form.power_dBW.value = dBW;
   my_form.power_dBm.value = dBm;
   my_form.power_W.value = W;
   return(1);
}

export function cmd_convert_W2dBWdBm(my_form) {
   var dBW, dBm, W;
   W = parseFloat(my_form.power_W.value);
   if (isNaN(W)||(W<=0)) {
      my_form.power_W.value = "";
      window.alert("Enter the power in W.");
      return(0);
      }
   dBW = 10*log10(W);
   dBm = dBW+30;
   my_form.power_dBW.value = dBW;
   my_form.power_dBm.value = dBm;
   my_form.power_W.value = W;
   return(1);
}

// --------------------------------------------------------------------------

export function cmd_convert_dBV2dBuVV(my_form) {
   var dBV, dBuV, V;
   dBV = parseFloat(my_form.amp_dBV.value);
   if (isNaN(dBV)) {
      my_form.amp_dBV.value = "";
      window.alert("Enter the amplitude in dBV.");
      return(0);
      }
   dBuV = dBV + 120;
   V = exp10(dBV/20);
   my_form.amp_dBV.value = dBV;
   my_form.amp_dBuV.value = dBuV;
   my_form.amp_V.value = V;
   return(1);
}

// export function cmd_convert_dBuV2dBVV(my_form) {
//    var dBV, dBuV, V;
//    dBuV = parseFloat(my_form.amp_dBuV.value);
//    if (isNaN(dBuV)) {
//       my_form.amp_dBuV.value = "";
//       window.alert("Enter the amplitude in dBuV.");
//       return(0);
//       }
//    dBV = dBuV - 120;
//    V = exp10(dBV/20);
//    my_form.amp_dBV.value = dBV;
//    my_form.amp_dBuV.value = dBuV;
//    my_form.amp_V.value = V;
//    return(1);
// }

// export function cmd_convert_V2dBVdBuV(my_form) {
//    var dBV, dBuV, V;
//    V = parseFloat(my_form.amp_V.value);
//    if (isNaN(V)||(V<=0)) {
//       my_form.amp_V.value = "";
//       window.alert("Enter the amplitude in V.");
//       return(0);
//       }
//    dBV = 20*log10(V);
//    dBuV = dBV + 120;
//    my_form.amp_dBV.value = dBV;
//    my_form.amp_dBuV.value = dBuV;
//    my_form.amp_V.value = V;
//    return(1);
// }

// // --------------------------------------------------------------------------

// export function cmd_convert_dBm2dBuV(my_form) {
//    var Zc, dBm, dBuV, p, u;
//    Zc = parseFloat(my_form.imp_Ohm.value);
//    if (isNaN(Zc)||(Zc<=0)) {
//       my_form.imp_Ohm.value = "";
//       window.alert("Enter the impedance in Ohm.");
//       return(0);
//       }
//    dBm = parseFloat(my_form.pwr_dBm.value);
//    if (isNaN(dBm)) {
//       my_form.pwr_dBm.value = "";
//       window.alert("Enter the power in dBm.");
//       return(0);
//       }
//    p = exp10(dBm/10)/1000;
//    u = Math.sqrt(p*Zc);
//    dBuV = 20*log10(u*1000000);
//    my_form.amp_dBuV.value = dBuV;
//    return(1);
// }

// export function cmd_convert_dBuV2dBm(my_form) {
//    var Zc, dBm, dBuV, p, u;
//    Zc = parseFloat(my_form.imp_Ohm.value);
//    if (isNaN(Zc)||(Zc<=0)) {
//       my_form.imp_Ohm.value = "";
//       window.alert("Enter the impedance in Ohm.");
//       return(0);
//       }
//    dBuV = parseFloat(my_form.amp_dBuV.value);
//    if (isNaN(dBuV)) {
//       my_form.pwr_dBuV.value = "";
//       window.alert("Enter the amplitude in dBuV.");
//       return(0);
//       }
//    u = exp10(dBuV/20)/1000000;
//    p = u*u/Zc;
//    dBm = 10*log10(p*1000);
//    my_form.pwr_dBm.value = dBm;
//    return(1);
// }

// --------------------------------------------------------------------------

// export function init_form_values() {
//    document.WdBmdBW.power_dBW.value = "-30";
//    document.WdBmdBW.power_dBm.value = "";
//    document.WdBmdBW.power_W.value = "";
//    document.VdBV.amp_dBV.value = "-60";
//    document.VdBV.amp_dBuV.value = "";
//    document.VdBV.amp_V.value = "";
//    document.dBmdBuV.imp_Ohm.value = "50";
//    document.dBmdBuV.pwr_dBm.value = "0";
//    document.dBmdBuV.amp_dBuV.value = "";
//    return(1);
// }

// --------------------------------------------------------------------------

// function calNBFL(cform) {
//    var rt=0;
//    reset_rest_from4(cform);
//    tmpvar = parseInt(cform.ip_1.value,10);
//    if (isNaN(tmpvar) || tmpvar > 255 || tmpvar < 0){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    tmpvar = parseInt(cform.ip_2.value,10);
//    if (isNaN(tmpvar) || tmpvar > 255 || tmpvar < 0){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    tmpvar = parseInt(cform.ip_3.value,10);
//    if (isNaN(tmpvar) || tmpvar > 255 || tmpvar < 0){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    tmpvar = parseInt(cform.ip_4.value,10);
//    if (isNaN(tmpvar) || tmpvar > 255 || tmpvar < 0){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    rt=calcNWmask(cform);
//    if (rt !=0 ){
//        // error
//        return(1);
//    }
//    tmpvar=parseInt(cform.bits.value,10);
//    if (tmpvar <0){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    if (tmpvar >32){
//        cform.numofaddr.value = '错误';
//        return(1);
//    }
//    if (tmpvar == 31){
//        cform.numofaddr.value = "two hosts";
//        cform.firstadr_1.value = cform.ip_1.value & cform.snm_1.value;
//        cform.firstadr_2.value = cform.ip_2.value & cform.snm_2.value;
//        cform.firstadr_3.value = cform.ip_3.value & cform.snm_3.value;
//        cform.firstadr_4.value = cform.ip_4.value & cform.snm_4.value;
//        //
//        cform.lastadr_1.value = cform.ip_1.value | (~ cform.snm_1.value & 0xff);
//        cform.lastadr_2.value = cform.ip_2.value | (~ cform.snm_2.value & 0xff);
//        cform.lastadr_3.value = cform.ip_3.value | (~ cform.snm_3.value & 0xff);
//        cform.lastadr_4.value = cform.ip_4.value | (~ cform.snm_4.value & 0xff);
//        return(1);
//    }
//    if (tmpvar == 32){
//        cform.numofaddr.value = "one host";
//        cform.firstadr_1.value = cform.ip_1.value;
//        cform.firstadr_2.value = cform.ip_2.value;
//        cform.firstadr_3.value = cform.ip_3.value;
//        cform.firstadr_4.value = cform.ip_4.value;
//        return(1);
//    }
//    cform.numofaddr.value = Math.pow(2,32 - tmpvar) - 2;
//    //
//    cform.bcast_1.value = cform.ip_1.value | (~ cform.snm_1.value & 0xff);
//    cform.bcast_2.value = cform.ip_2.value | (~ cform.snm_2.value & 0xff);
//    cform.bcast_3.value = cform.ip_3.value | (~ cform.snm_3.value & 0xff);
//    cform.bcast_4.value = cform.ip_4.value | (~ cform.snm_4.value & 0xff);
//    //
//    cform.nwadr_1.value = cform.ip_1.value & cform.snm_1.value;
//    cform.nwadr_2.value = cform.ip_2.value & cform.snm_2.value;
//    cform.nwadr_3.value = cform.ip_3.value & cform.snm_3.value;
//    cform.nwadr_4.value = cform.ip_4.value & cform.snm_4.value;
//    //
//    cform.firstadr_1.value = cform.nwadr_1.value;
//    cform.firstadr_2.value = cform.nwadr_2.value;
//    cform.firstadr_3.value = cform.nwadr_3.value;
//    cform.firstadr_4.value = parseInt(cform.nwadr_4.value) + 1;
//    //
//    cform.lastadr_1.value = cform.bcast_1.value;
//    cform.lastadr_2.value = cform.bcast_2.value;
//    cform.lastadr_3.value = cform.bcast_3.value;
//    cform.lastadr_4.value = parseInt(cform.bcast_4.value) - 1;
//    return(0);
// }